import { pageRegexConfigMap } from './configs';
import type { PageRoute } from './types';

export const isPageRoute = (value: unknown): value is PageRoute => (
  typeof value === 'string'
  && Object.values(pageRegexConfigMap).some(regex => regex.test(value))
);

export const pathnameToPageRoute = (
  value: PageRoute,
): PageRoute => Object.entries(pageRegexConfigMap)
  .find(([, regex]) => regex.test(value))?.[0] as PageRoute;
